<template>
    <v-dialog v-model="localStatus" max-width="80vw" persistent>
        <v-form ref="form" v-model="validForm" @submit.prevent="submit">
            <v-card>
                <v-card-title>
                    <v-icon left>mdi-wrench</v-icon>
                    New {{ type.name }} Invoice:
                    <v-spacer />
                </v-card-title>
                <v-card-text>
                    <v-row no-gutters class="ma-1">
                        <v-col cols="12" md="2">
                            <v-text-field
                                v-model="invoiceForm.id"
                                label="Invoice ID"
                                disabled
                                dense
                                style="cursor: not-allowed !important;"
                                prepend-inner-icon="mdi-numeric"
                                outlined
                                hide-details
                                class="rounded-0"
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            md="4"
                            v-show="
                                getActiveModelType('transportation')
                            "
                        >
                            <v-autocomplete
                                v-model="invoiceForm.model_id"
                                :items="collection.models"
                                item-text="name"
                                item-value="id"
                                label="Equipment"
                                dense
                                prepend-inner-icon="mdi-card-search"
                                :append-icon="
                                    loading.models ? 'mdi-loading mdi-spin' : ''
                                "
                                outlined
                                hide-details
                                class="rounded-0"
                                @change="manageOnChangeEvent('invoiceForm', 'model_id')"
                            />
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-text-field
                                v-model="invoiceForm.invoice_number"
                                :rules="[rules.required]"
                                label="Invoice Number"
                                dense
                                @change="manageOnChangeEvent('invoiceForm', 'invoice_number')"
                                prepend-inner-icon="mdi-numeric"
                                outlined
                                hide-details
                                class="rounded-0"
                            />
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-autocomplete
                                v-model="
                                    invoiceForm.maintenance_purchase_order_id
                                "
                                :items="collection.purchaseOrders"
                                item-text="number"
                                item-value="id"
                                label="Purchase Order Number"
                                dense
                                :disabled="!invoiceForm.model_id"
                                prepend-inner-icon="mdi-numeric"
                                :append-icon="
                                    loading.purchaseOrders
                                        ? 'mdi-loading mdi-spin'
                                        : ''
                                "
                                :loading="loading.purchaseOrders"
                                :search-input.sync="search.purchaseOrder"
                                outlined
                                hide-details
                                class="rounded-0"
                            >
                                <template
                                    v-slot:item="{ active, item, attrs, on }"
                                >
                                    <v-list-item
                                        v-on="on"
                                        v-bind="attrs"
                                        #default="{ active }"
                                    >
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <v-row
                                                    no-gutters
                                                    align="center"
                                                >
                                                    <span>{{
                                                        item.purchase_order_number
                                                    }}</span>
                                                    <v-spacer></v-spacer>
                                                    <v-chip
                                                        text-color="white"
                                                        color="indigo"
                                                        small
                                                        >{{
                                                            item.vendor.name
                                                        }}</v-chip
                                                    >
                                                </v-row>
                                            </v-list-item-title>
                                            <v-list-item-subtitle>
                                                <v-row
                                                    no-gutters
                                                    align="center"
                                                >
                                                    <span>
                                                        {{ item.description }}
                                                    </span>
                                                    <v-spacer></v-spacer>
                                                    <v-chip
                                                        text-color="white"
                                                        color="success"
                                                        small
                                                        >{{
                                                            item.approver.email
                                                        }}</v-chip
                                                    >
                                                </v-row>
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="ma-1">
                        <v-col cols="12" md="2">
                            <!--<date-menu
                                v-model="invoiceForm.invoice_issued_at"
                                :properties="dateMenuProperties"
                                :date="invoiceForm.invoice_issued_at"
                                @update:date="
                                    invoiceForm.invoice_issued_at = $event
                                "
                                @change="manageOnChangeEvent('invoiceForm', 'invoice_issued_at')"
                            ></date-menu>-->
                            <v-menu
                                v-model="dateMenu"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="invoiceForm.invoice_issued_at"
                                        label="Invoice Date"
                                        prepend-inner-icon="mdi-calendar"
                                        single-line
                                        placeholder="YYYY-MM-DD"
                                        v-mask="'####-##-##'"
                                        outlined
                                        hint="Select the date the invoice was issued"
                                        persistent-hint
                                        @change="manageOnChangeEvent('invoiceForm', 'invoice_issued_at')"
                                        dense
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="invoiceForm.invoice_issued_at"
                                    no-title
                                    @input="dateMenu = false"
                                    @change="manageOnChangeEvent('invoiceForm', 'invoice_issued_at')"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-autocomplete
                                v-model="invoiceForm.company_id"
                                :rules="[rules.required]"
                                :items="collection.companies"
                                item-text="CompanyName"
                                item-value="CompanyID"
                                label="Company"
                                dense
                                @change="manageOnChangeEvent('invoiceForm', 'company_id')"
                                prepend-inner-icon="mdi-office-building"
                                outlined
                                hide-details
                                class="rounded-0"
                            />
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-autocomplete
                                v-model="invoiceForm.region_id"
                                :rules="[rules.required]"
                                :items="collection.regions"
                                item-text="PrincipalRegion"
                                item-value="PrincipalRegionID"
                                label="Region"
                                dense
                                @change="manageOnChangeEvent('invoiceForm', 'region_id')"
                                prepend-inner-icon="mdi-map"
                                outlined
                                hide-details
                                class="rounded-0"
                            />
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-autocomplete
                                v-model="invoiceForm.maintenance_tax_region_id"
                                :rules="[rules.required]"
                                :items="collection.taxRegions"
                                item-text="name"
                                item-value="id"
                                label="Tax Region"
                                dense
                                @change="manageOnChangeEvent('invoiceForm', 'maintenance_tax_region_id')"
                                prepend-inner-icon="mdi-map-marker"
                                persistent-hint
                                :hint="
                                    invoiceForm.maintenance_tax_region_id
                                        ? collection.taxRegions.find(
                                              taxRegion =>
                                                  taxRegion.id ===
                                                  invoiceForm.maintenance_tax_region_id
                                          ).rate + '%'
                                        : 'Select the tax region where the maintenance was performed'
                                "
                                outlined
                                class="rounded-0"
                            >
                                <template v-slot:item="{ item }">
                                    <span
                                        >{{ item.name }} -
                                        {{ item.rate }}%</span
                                    >
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-autocomplete
                                v-model="invoiceForm.maintenance_vendor_id"
                                :rules="[rules.required]"
                                :items="this.dialogStatus && this.dialogType == 'new' ? filteredVendorItems : collection.vendors"
                                item-text="name"
                                item-value="id"
                                @change="manageOnChangeEvent('invoiceForm', 'maintenance_vendor_id')"
                                @update:search-input="handleVendorInput"
                                label="Vendor"
                                dense
                                prepend-inner-icon="mdi-account"
                                outlined
                                hide-details
                                class="rounded-0"
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            md="2"
                            v-if="getActiveModelType('trailer')"
                        >
                            <v-text-field
                                v-model="invoiceForm.hub_reading"
                                :rules="[rules.float(0, 999999999)]"
                                label="Hub Reading"
                                dense
                                prepend-inner-icon="mdi-speedometer"
                                outlined
                                hide-details
                                class="rounded-0"
                            />
                        </v-col>
                    </v-row>
                    <v-row no-gutters v-if="getActiveModelType('truck')" class="mt-3">
                        <v-col cols="12" md="2">
                            <v-text-field
                                v-model="invoiceForm.odometer_entry"
                                label="Odometer Entry"
                                dense
                                prepend-inner-icon="mdi-numeric"
                                outlined
                                hide-details
                                class="rounded-0"
                            />
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-text-field
                                v-model="invoiceForm.odometer_exit"
                                label="Odometer Exit"
                                dense
                                prepend-inner-icon="mdi-numeric"
                                outlined
                                hide-details
                                class="rounded-0"
                            />
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-autocomplete
                                v-model="invoiceForm.replacement_truck_id"
                                :items="collection.models"
                                item-text="name"
                                item-value="id"
                                label="Replacement Truck"
                                dense
                                prepend-inner-icon="mdi-card-search"
                                outlined
                                hide-details
                                class="rounded-0"
                            />
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-text-field
                                v-model="invoiceForm.another_replacement_truck"
                                label="Another replacement truck"
                                dense
                                prepend-inner-icon="mdi-truck"
                                outlined
                                persistent-hint
                                hint="Is there another replacement truck? Enter it here"
                                class="rounded-0"
                            />
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-menu
                                v-model="replacementTruckUseAtMenu.start"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="invoiceForm.start_of_replacement_truck_use_at"
                                        label="Start of use"
                                        prepend-inner-icon="mdi-calendar"
                                        single-line
                                        placeholder="YYYY-MM-DD"
                                        v-mask="'####-##-##'"
                                        outlined
                                        hint="Start of replacement truck use"
                                        persistent-hint
                                        dense
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="invoiceForm.start_of_replacement_truck_use_at"
                                    no-title
                                    @input="replacementTruckUseAtMenu.start = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-menu
                                v-model="replacementTruckUseAtMenu.end"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="invoiceForm.end_of_replacement_truck_use_at"
                                        label="End of use"
                                        prepend-inner-icon="mdi-calendar"
                                        single-line
                                        placeholder="YYYY-MM-DD"
                                        v-mask="'####-##-##'"
                                        outlined
                                        hint="End of replacement truck use"
                                        persistent-hint
                                        dense
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="invoiceForm.end_of_replacement_truck_use_at"
                                    no-title
                                    @input="replacementTruckUseAtMenu.end = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-autocomplete
                                v-model="
                                    invoiceForm.maintenance_vendor_rent_agreement_id
                                "
                                :items="collection.rentAgreements"
                                item-text="agreement_number"
                                item-value="id"
                                label="Vendor Agreement"
                                dense
                                prepend-inner-icon="mdi-account"
                                outlined
                                hide-details
                                class="rounded-0"
                            />
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="ma-1" style="margin: 20px 0!important;">
                        <v-col
                            cols="12"
                            md="3"
                            v-if="getActiveModelType('transportation')"
                            style="padding-right: 20px;"
                        >
                            <v-autocomplete
                                v-model="
                                    invoiceForm.maintenance_type_id
                                "
                                :items="collection.maintenanceTypes"
                                item-text="description"
                                item-value="id"
                                label="Maintenance Type"
                                dense
                                prepend-inner-icon="mdi-bus-wrench"
                                outlined
                                hide-details
                                class="rounded-0"
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            md="3"
                            v-if="getActiveModelType('transportation')"
                            style="max-width: 20%;"
                        >
                            <v-checkbox
                                v-model="invoiceForm.is_incident"
                                label="Incident"
                                hint="Was the maintenance performed due to an incident?"
                                persistent-hint
                                dense
                                :disabled="invoiceForm.maintenance_type_id !== 2"
                                style="padding: 0;margin: 0;"
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            md="3"
                            v-if="getActiveModelType('transportation') && invoiceForm.is_incident"
                        >
                            <v-text-field
                                v-model="invoiceForm.incident_number"
                                label="Incident Number"
                                dense
                                prepend-inner-icon="mdi-truck-alert"
                                outlined
                                hide-details
                                class="rounded-0"
                            />
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="ma-1" style="margin-bottom: 20px!important;">
                        <v-col
                            cols="12"
                            md="3"
                            v-if="getActiveModelType('transportation')"
                        >
                            <v-checkbox
                                v-model="invoiceForm.is_service_call"
                                label="Roadside Call"
                                hint="Was the maintenance performed after a Roadside/Service call?"
                                persistent-hint
                                dense
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            md="3"
                            v-if="getActiveModelType('transportation')"
                        >
                            <v-checkbox
                                v-model="invoiceForm.is_oo_charge"
                                label="Charge O.O."
                                hint="Charge the Owner Operator for the maintenance?"
                                persistent-hint
                                dense
                            />
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-file-input
                                v-model="files"
                                label="Add invoice file"
                                prepend-icon="mdi-paperclip"
                                outlined
                                dense
                                hide-details
                                :multiple="false"
                                @change="handleFileInput"
                            ></v-file-input>
                        </v-col>
                        <v-col v-if="dialogType == 'edit'" cols="12" md="3">
                            <v-btn
                                class="ma-4"
                                outlined
                                color="indigo"
                                @click="viewInvoiceFile"
                            >
                                View invoice file
                                <v-icon
                                    right
                                    dark
                                >
                                    mdi-file-eye-outline
                                </v-icon>
                            </v-btn>
                        </v-col>
                        <!--<v-col cols="12" md="3">
                            <v-checkbox
                                v-model="invoiceForm.is_stock"
                                label="Stock"
                                hint="Is this a stock invoice?"
                                persistent-hint
                                dense
                            />
                        </v-col>-->
                    </v-row>
                    <v-row no-gutters class="ma-1">
                        <v-col cols="12" md="6">
                            <v-textarea
                                v-model="invoiceForm.description"
                                label="Description"
                                hint="Official description of the invoice"
                                persistent-hint
                                dense
                                rows="3"
                                outlined
                                hide-details
                                class="rounded-0"
                            />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-textarea
                                v-model="invoiceForm.comments"
                                label="Comments"
                                hint="For internal use only."
                                persistent-hint
                                dense
                                rows="3"
                                outlined
                                hide-details
                                class="rounded-0"
                            />
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="12">
                            <v-card>
                                <v-card-title>
                                    <v-icon left>mdi-invoice</v-icon>
                                    Invoice Details:
                                    <v-spacer />
                                    <v-tooltip left v-if="type.value === 'supplies'">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-chip
                                                class="ma-2"
                                                :color="inventoryItemFound.Status ? 'success' : 'error'"
                                                outlined
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                <v-icon left v-if="inventoryItemFound.Status">
                                                    mdi-package-variant-closed-check
                                                </v-icon>
                                                <v-icon left v-else>
                                                    mdi-package-variant-closed-remove
                                                </v-icon>
                                                Inventory Status
                                            </v-chip>
                                        </template>
                                        <span v-if="inventoryItemFound.Status">Item already in inventory</span>
                                        <span v-else>Item not found in the inventory</span>
                                    </v-tooltip>
                                </v-card-title>
                                <v-card-text>
                                    <v-row no-gutters class="ma-1">
                                        <v-col cols="12" md="2">
                                            <v-autocomplete
                                                v-model="
                                                    invoiceExpenseForm.maintenance_expense_category_id
                                                "
                                                :items="
                                                    expenseCategoriesFiltered
                                                "
                                                @change="manageOnChangeEvent('invoiceExpenseForm', 'maintenance_expense_category_id')"
                                                item-value="id"
                                                item-text="name"
                                                label="Expense Category"
                                                hint="Select the category of expense"
                                                persistent-hint
                                                dense
                                                outlined
                                                class="rounded-0"
                                            >
                                                <template
                                                    v-slot:item="{ item }"
                                                >
                                                    <span
                                                        >{{ item.name }} -
                                                        {{
                                                            item.description
                                                        }}</span
                                                    >
                                                </template>
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <v-autocomplete
                                                v-model="
                                                    invoiceExpenseForm.maintenance_expense_sub_category_id
                                                "
                                                :items="
                                                    expenseSubCategoriesFiltered
                                                "
                                                item-value="id"
                                                item-text="name"
                                                label="Expense Subcategory"
                                                hint="Select the subcategory of expense"
                                                persistent-hint
                                                dense
                                                outlined
                                                class="rounded-0"
                                                @change="manageOnChangeEvent('invoiceExpenseForm', 'maintenance_expense_sub_category_id')"
                                            >
                                                <template
                                                    v-slot:item="{ item }"
                                                >
                                                    <span
                                                        >{{ item.name }} -
                                                        {{
                                                            item.description
                                                        }}</span
                                                    >
                                                </template>
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" md="2" v-if="type.value === 'supplies'">
                                            <v-autocomplete
                                                v-model="
                                                    invoiceExpenseForm.maintenance_item_id
                                                "
                                                :items="
                                                    itemsFiltered
                                                "
                                                @change="manageOnChangeEvent('invoiceExpenseForm', 'maintenance_item_id')"
                                                item-value="id"
                                                item-text="name"
                                                label="Item"
                                                hint="Select the item"
                                                persistent-hint
                                                dense
                                                outlined
                                                class="rounded-0"
                                            >
                                                <template
                                                    v-slot:item="{ item }"
                                                >
                                                    <span>
                                                        {{ item.name }}
                                                    </span>
                                                </template>
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="2"
                                            v-show="showTireBrand()"
                                        >
                                            <v-autocomplete
                                                v-model="
                                                    invoiceExpenseForm.maintenance_tire_brand_id
                                                "
                                                :items="maintenanceTireBrands"
                                                item-value="id"
                                                item-text="name"
                                                label="Tire Brand"
                                                hint="Select the tire brand"
                                                persistent-hint
                                                dense
                                                outlined
                                                class="rounded-0"
                                            >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <v-text-field
                                                v-model="
                                                    invoiceExpenseForm.custom_tax_rate
                                                "
                                                type="number"
                                                label="Tax Rate"
                                                hint="Tax rate based on the Tax Region"
                                                persistent-hint
                                                @change="manageOnChangeEvent('invoiceExpenseForm', 'custom_tax_rate')"
                                                dense
                                                outlined
                                                class="rounded-0"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters class="ma-1">
                                        <v-col cols="12" md="2">
                                            <v-text-field
                                                v-model="
                                                    invoiceExpenseForm.quantity
                                                "
                                                type="number"
                                                :label="type.value === 'supplies' ? 'Quantity to add' : 'Quantity'"
                                                :hint="type.value === 'supplies' ? 'How many units to add?' : 'How many units?'"
                                                persistent-hint
                                                dense
                                                outlined
                                                class="rounded-0"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="2" v-if="type.value === 'supplies'">
                                            <v-text-field
                                                v-model="
                                                    invoiceExpenseForm.current_quantity
                                                "
                                                type="number"
                                                label="Current Quantity"
                                                hint="Current quantity in stock"
                                                persistent-hint
                                                dense
                                                outlined
                                                class="rounded-0"
                                                disabled
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <v-text-field
                                                v-model="
                                                    invoiceExpenseForm.unit_cost
                                                "
                                                type="number"
                                                label="Unit Cost"
                                                hint="Cost per unit"
                                                @change="manageOnChangeEvent('invoiceExpenseForm', 'unit_cost')"
                                                persistent-hint
                                                dense
                                                outlined
                                                class="rounded-0"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <v-text-field
                                                v-model="
                                                    invoiceExpenseForm.subtotal_cost
                                                "
                                                label="Subtotal Cost"
                                                hint="Cost before tax"
                                                persistent-hint
                                                disabled
                                                dense
                                                outlined
                                                class="rounded-0"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <v-text-field
                                                v-model="invoiceExpenseForm.tax"
                                                label="Tax"
                                                hint="Tax cost"
                                                persistent-hint
                                                disabled
                                                dense
                                                outlined
                                                class="rounded-0"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <v-text-field
                                                v-model="
                                                    invoiceExpenseForm.total_cost
                                                "
                                                label="Total Cost"
                                                persistent-hint
                                                disabled
                                                dense
                                                outlined
                                                class="rounded-0"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters class="ma-1">
                                        <v-col cols="12" md="6">
                                            <v-textarea
                                                v-model="
                                                    invoiceExpenseForm.description
                                                "
                                                label="Description"
                                                hint="If applicable"
                                                persistent-hint
                                                rows="2"
                                                dense
                                                outlined
                                                class="rounded-0"
                                            ></v-textarea>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-textarea
                                                v-model="
                                                    invoiceExpenseForm.comments
                                                "
                                                label="Comments"
                                                hint="If applicable"
                                                persistent-hint
                                                rows="2"
                                                dense
                                                outlined
                                                class="rounded-0"
                                            ></v-textarea>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" md="2">
                                            <v-btn
                                                color="primary"
                                                dark
                                                depressed
                                                block
                                                @click="addExpense()"
                                            >
                                                <v-icon left>mdi-plus</v-icon>
                                                Add Expense
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" md="12">
                                            <v-data-table
                                                :headers="expenseHeaders"
                                                :items="invoiceExpenses"
                                                :items-per-page="10"
                                                class="elevation-1 mtt-table"
                                            >
                                                <template
                                                    v-slot:item.category="{
                                                        item
                                                    }"
                                                >
                                                    <v-edit-dialog
                                                        :return-value.sync="
                                                            item.category
                                                        "
                                                        @save="
                                                            updateExpense(item)
                                                        "
                                                        @change="
                                                            getExpenseSubCategoriesFilteredByCategory(
                                                                item.maintenance_expense_category_id
                                                            )
                                                        "
                                                        large
                                                    >
                                                        {{
                                                            getCategoryName(
                                                                item.maintenance_expense_category_id
                                                            )
                                                        }}
                                                        <template v-slot:input>
                                                            <v-autocomplete
                                                                v-model="
                                                                    item.maintenance_expense_category_id
                                                                "
                                                                :items="
                                                                    expenseCategoriesFiltered
                                                                "
                                                                item-text="name"
                                                                item-value="id"
                                                                label="Expense Category"
                                                                dense
                                                                outlined
                                                                hide-details
                                                                class="rounded-0"
                                                            >
                                                            </v-autocomplete>
                                                        </template>
                                                    </v-edit-dialog>
                                                </template>
                                                <template
                                                    v-slot:item.subcategory="{
                                                        item
                                                    }"
                                                >
                                                    <v-edit-dialog
                                                        :return-value.sync="
                                                            item.subcategory
                                                        "
                                                        @save="
                                                            updateExpense(item)
                                                        "
                                                        large
                                                    >
                                                        {{
                                                            getSubcategoryName(
                                                                item.maintenance_expense_sub_category_id
                                                            )
                                                        }}
                                                        <template v-slot:input>
                                                            <v-autocomplete
                                                                v-model="
                                                                    item.maintenance_expense_sub_category_id
                                                                "
                                                                :items="
                                                                    expenseSubCategoriesFiltered
                                                                "
                                                                item-text="name"
                                                                item-value="id"
                                                                label="Expense Subcategory"
                                                                dense
                                                                outlined
                                                                hide-details
                                                                class="rounded-0"
                                                            >
                                                            </v-autocomplete>
                                                            <v-btn
                                                                text
                                                                @click="
                                                                    getExpenseSubCategoriesFilteredByCategory(
                                                                        item.maintenance_expense_category_id
                                                                    )
                                                                "
                                                            >
                                                                <v-icon small>
                                                                    mdi-refresh
                                                                </v-icon>
                                                                Refresh
                                                                subcategories
                                                            </v-btn>
                                                        </template>
                                                    </v-edit-dialog>
                                                </template>
                                                <template
                                                    v-if="type.value === 'supplies'"
                                                    v-slot:item.item="{
                                                        item
                                                    }"
                                                >
                                                    <v-edit-dialog
                                                        :return-value.sync="
                                                            item.item
                                                        "
                                                        @save="
                                                            updateExpense(item)
                                                        "
                                                        large
                                                    >
                                                        {{
                                                            getItemName(
                                                                item.maintenance_item_id
                                                            )
                                                        }}
                                                        <template v-slot:input>
                                                            <v-autocomplete
                                                                v-model="
                                                                    item.maintenance_item_id
                                                                "
                                                                :items="
                                                                    itemsFiltered
                                                                "
                                                                item-text="name"
                                                                item-value="id"
                                                                label="Item"
                                                                dense
                                                                outlined
                                                                hide-details
                                                                class="rounded-0"
                                                            >
                                                            </v-autocomplete>
                                                            <v-btn
                                                                text
                                                                @click="
                                                                    getItemsFilteredBySubCategories(
                                                                        item.maintenance_expense_sub_category_id
                                                                    )
                                                                "
                                                            >
                                                                <v-icon small>
                                                                    mdi-refresh
                                                                </v-icon>
                                                                Refresh
                                                                items
                                                            </v-btn>
                                                        </template>
                                                    </v-edit-dialog>
                                                </template>
                                                <template
                                                    v-slot:item.description="{
                                                        item
                                                    }"
                                                >
                                                    <v-edit-dialog
                                                        :return-value.sync="
                                                            item.description
                                                        "
                                                        @save="
                                                            updateExpense(item)
                                                        "
                                                        large
                                                    >
                                                        {{ item.description }}
                                                        <template v-slot:input>
                                                            <v-text-field
                                                                v-model="
                                                                    item.description
                                                                "
                                                                single-line
                                                            ></v-text-field>
                                                        </template>
                                                    </v-edit-dialog>
                                                </template>
                                                <template
                                                    v-slot:item.comments="{
                                                        item
                                                    }"
                                                >
                                                    <v-edit-dialog
                                                        :return-value.sync="
                                                            item.comments
                                                        "
                                                        @save="
                                                            updateExpense(item)
                                                        "
                                                        large
                                                    >
                                                        {{ item.comments }}
                                                        <template v-slot:input>
                                                            <v-text-field
                                                                v-model="
                                                                    item.comments
                                                                "
                                                                single-line
                                                            ></v-text-field>
                                                        </template>
                                                    </v-edit-dialog>
                                                </template>

                                                <template
                                                    v-slot:item.custom_tax_rate="{
                                                        item
                                                    }"
                                                >
                                                    <v-edit-dialog
                                                        :return-value.sync="
                                                            item.custom_tax_rate
                                                        "
                                                        @save="
                                                            updateExpense(item)
                                                        "
                                                        large
                                                    >
                                                        {{
                                                            item.custom_tax_rate
                                                        }}
                                                        <template v-slot:input>
                                                            <v-text-field
                                                                v-model="
                                                                    item.custom_tax_rate
                                                                "
                                                                single-line
                                                                type="number"
                                                                :disabled="false"
                                                                @change="
                                                                    calculateItemCosts(
                                                                        item
                                                                    )
                                                                "
                                                            ></v-text-field>
                                                        </template>
                                                    </v-edit-dialog>
                                                </template>
                                                <template
                                                    v-slot:item.quantity="{
                                                        item
                                                    }"
                                                >
                                                    <v-edit-dialog
                                                        :return-value.sync="
                                                            item.quantity
                                                        "
                                                        @save="
                                                            updateExpense(item)
                                                        "
                                                        large
                                                    >
                                                        {{ item.quantity }}
                                                        <template v-slot:input>
                                                            <v-text-field
                                                                v-model="
                                                                    item.quantity
                                                                "
                                                                single-line
                                                                type="number"
                                                                :disabled="false"
                                                                @change="
                                                                    calculateItemCosts(
                                                                        item
                                                                    )
                                                                "
                                                            ></v-text-field>
                                                        </template>
                                                    </v-edit-dialog>
                                                </template>
                                                <template
                                                    v-slot:item.unit_cost="{
                                                        item
                                                    }"
                                                >
                                                    <v-edit-dialog
                                                        :return-value.sync="
                                                            item.unit_cost
                                                        "
                                                        @save="
                                                            updateExpense(item)
                                                        "
                                                        large
                                                    >
                                                        {{ item.unit_cost }}
                                                        <template v-slot:input>
                                                            <v-text-field
                                                                v-model="
                                                                    item.unit_cost
                                                                "
                                                                single-line
                                                                type="number"
                                                                :disabled="false"
                                                                @change="
                                                                    calculateItemCosts(
                                                                        item
                                                                    )
                                                                "
                                                            ></v-text-field>
                                                        </template>
                                                    </v-edit-dialog>
                                                </template>
                                                <template
                                                    v-slot:item.actions="{
                                                        item
                                                    }"
                                                >
                                                    <v-icon
                                                        small
                                                        class="mr-2"
                                                        @click="
                                                            deleteExpense(item)
                                                        "
                                                        >mdi-delete</v-icon
                                                    >
                                                </template>
                                            </v-data-table>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters class="ma-1">
                                        <v-spacer></v-spacer>
                                        <v-col cols="12" md="2">
                                            <v-text-field
                                                v-model="
                                                    invoiceForm.subtotal_cost
                                                "
                                                label="Subtotal Cost"
                                                hint="Total cost before tax"
                                                persistent-hint
                                                dense
                                                outlined
                                                disabled
                                                class="rounded-0"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <v-text-field
                                                v-model="invoiceForm.total_cost"
                                                label="Total Cost"
                                                hint="Total cost after tax"
                                                persistent-hint
                                                dense
                                                outlined
                                                disabled
                                                class="rounded-0"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <small class="red--text">*indicates required field</small>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <!--<v-btn
                        color="blue darken-1"
                        text
                        @click="resetForm()"
                        :disabled="dialogType !== 'new'"
                    >
                        Clear
                    </v-btn>-->
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="handleCloseInvoiceForm()"
                    >
                        Close
                    </v-btn>
                    <v-btn
                        v-if="dialogType == 'new'"
                        color="blue darken-1"
                        text
                        type="submit"
                        :disabled="!validForm"
                    >
                        Save
                    </v-btn>
                    <v-btn
                        v-if="dialogType == 'edit'"
                        color="blue darken-1"
                        text
                        type="submit"
                        :disabled="!validForm"
                    >
                        Update
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>

        <v-dialog
            v-model="inventoryItemFound.Show"
            persistent
            max-width="1400px"
            transition="dialog-bottom-transition"
        >
            <v-card style="padding: 0 20px;">
                <v-card-title style="padding-left: 0;">
                    {{ inventoryItemFound.TaxRate.Show ? 'Different Tax Rate' : 'Inventory Item Found' }}
                </v-card-title>
                <v-card-text style="font-size: 16px;padding-left: 0;">
                    {{ inventoryItemFound.TaxRate.Show ? 'It has been detected that the tax rate value you have entered is different from the tax rate value that the item currently has in the inventory, do you wish to continue?' : 
                    'Based on your filters a item has been found in inventory' }}
                </v-card-text>
                <table style="margin-bottom: 20px;" v-if="inventoryItemFound.TaxRate.Show">
                    <tr>
                        <th style="font-size: 14px;">Current Tax Rate</th>
                        <th style="font-size: 14px;">New Tax Rate</th>
                    </tr>
                    <tr>
                        <td style="font-size: 14px;">{{ inventoryItemFound.TaxRate.Current }}</td>
                        <td style="font-size: 14px;">{{ inventoryItemFound.TaxRate.New }}</td>
                    </tr>
                </table>
                <table style="margin-bottom: 20px;">
                    <tr>
                        <th style="font-size: 14px;">Region</th>
                        <th style="font-size: 14px;">Vendor</th>
                        <th style="font-size: 14px;">Category</th>
                        <th style="font-size: 14px;">Subcategory</th>
                        <th style="font-size: 14px;">Item</th>
                        <th style="font-size: 14px;">UnitCost</th>
                        <th style="font-size: 14px;">TaxRate</th>
                        <th style="font-size: 14px;">CurrentQuantity</th>
                    </tr>
                    <tr>
                        <td style="font-size: 14px;">{{ inventoryItemFound.Data.Region }}</td>
                        <td style="font-size: 14px;">{{ inventoryItemFound.Data.Vendor }}</td>
                        <td style="font-size: 14px;">{{ inventoryItemFound.Data.Category }}</td>
                        <td style="font-size: 14px;">{{ inventoryItemFound.Data.Subcategory }}</td>
                        <td style="font-size: 14px;">{{ inventoryItemFound.Data.Item }}</td>
                        <td style="font-size: 14px;">{{ inventoryItemFound.Data.UnitCost }}</td>
                        <td style="font-size: 14px;">{{ inventoryItemFound.Data.TaxRate }}</td>
                        <td style="font-size: 14px;">{{ inventoryItemFound.Data.CurrentQuantity }}</td>
                    </tr>
                </table>
                <div style="display: flex;justify-content: space-between;padding: 0 0 15px;" v-if="inventoryItemFound.TaxRate.Show">
                    <v-btn text @click="manageTaxRate('continue')">
                        Continue
                    </v-btn>
                    <v-btn text @click="manageTaxRate('cancel')">
                        Cancel
                    </v-btn>
                </div>
                <div style="display: flex;justify-content: space-between;padding: 0 0 15px;" v-else>
                    <div style="width: 80px;height: 35px;"></div>
                    <v-btn text @click="inventoryItemFound.Action('close')">
                        Close
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="currentExpenseList.Show"
            persistent
            max-width="1400px"
            transition="dialog-bottom-transition"
        >
            <v-card style="padding: 0 20px;">
                <v-card-title style="padding-left: 0;">
                    Pending Expense List
                </v-card-title>
                <v-card-text style="font-size: 16px;padding-left: 0;">
                    You have expenses currently on the list. Before changing region or vendor please save your changes. Do you want to save your current expenses or continue with a new list?
                </v-card-text>
                <v-row>
                    <v-col cols="12" md="12">
                        <v-data-table
                            :headers="expenseHeaders"
                            :items="invoiceExpenses"
                            :items-per-page="10"
                            class="elevation-1 mtt-table"
                        >
                            <template
                                v-slot:item.category="{ item }"
                            >
                                {{ getCategoryName(item.maintenance_expense_category_id) }}
                            </template>
                            <template
                                v-slot:item.subcategory="{ item }"
                            >
                                {{ getSubcategoryName(item.maintenance_expense_sub_category_id) }}
                            </template>
                            <template
                                v-if="type.value === 'supplies'"
                                v-slot:item.item="{ item }"
                            >
                                {{ getItemName(item.maintenance_item_id) }}
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
                <div style="display: flex;justify-content: space-between;padding: 0 0 15px;margin-top: 10px;">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn 
                                outlined 
                                color="indigo"
                                @click="manageCurrentExpenseList('save')"
                                v-bind="attrs"
                                v-on="on"
                            >
                                Continue and save
                            </v-btn>
                        </template>
                        <span>Save the current expense list and restart the form to create a new one</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn 
                                outlined 
                                color="indigo"
                                @click="manageCurrentExpenseList('new')"
                                v-bind="attrs"
                                v-on="on"
                            >
                                Create a new list
                            </v-btn>
                        </template>
                        <span>The current expense list is lost and restarts the form</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn 
                                outlined 
                                color="indigo"
                                @click="manageCurrentExpenseList('close')"
                                v-bind="attrs"
                                v-on="on"
                            >
                                Close
                            </v-btn>
                        </template>
                        <span>Continue to add expenses to the current list</span>
                    </v-tooltip>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="neighborInvoiceDateMatches.Show"
            persistent
            max-width="1000px"
            transition="dialog-bottom-transition"
        >
            <v-card style="padding: 0 20px;">
                <v-card-title style="padding-left: 0;">
                    Neighbor Invoice Date Matches
                </v-card-title>
                <v-card-text style="font-size: 16px;padding-left: 0;">
                    The following dates have been found around the entered invoice date
                </v-card-text>
                <table style="margin-bottom: 20px;">
                    <tr>
                        <th style="font-size: 14px;">ShiftDate</th>
                        <th style="font-size: 14px;">Region</th>
                        <th style="font-size: 14px;">City</th>
                        <th style="font-size: 14px;">Province</th>
                        <th style="font-size: 14px;">TaxRate</th>
                        <th style="font-size: 14px;"></th>
                    </tr>
                    <tr v-if="Object.keys(neighborInvoiceDateMatches.Previous).length">
                        <td style="font-size: 14px;">{{ neighborInvoiceDateMatches.Previous.ShiftData.ShiftMatched[0].Date }}</td>
                        <td style="font-size: 14px;">{{ neighborInvoiceDateMatches.Previous.RegionData[0].PrincipalRegionName }}</td>
                        <td style="font-size: 14px;">{{ neighborInvoiceDateMatches.Previous.RegionData[0].StationCity }}</td>
                        <td style="font-size: 14px;">{{ neighborInvoiceDateMatches.Previous.RegionData[0].TaxRegionName }}</td>
                        <td style="font-size: 14px;">{{ neighborInvoiceDateMatches.Previous.RegionData[0].TaxRegionRate }}</td>
                        <td style="font-size: 14px;">
                            <v-btn
                                @click="handleSelectRegionByInvoiceDate(neighborInvoiceDateMatches.Previous)"
                                color="indigo"
                                small
                                dense
                                outlined
                            >
                                Select
                            </v-btn>
                        </td>
                    </tr>
                    <tr v-if="Object.keys(neighborInvoiceDateMatches.Next).length">
                        <td style="font-size: 14px;">{{ neighborInvoiceDateMatches.Next.ShiftData.ShiftMatched[0].Date }}</td>
                        <td style="font-size: 14px;">{{ neighborInvoiceDateMatches.Next.RegionData[0].PrincipalRegionName }}</td>
                        <td style="font-size: 14px;">{{ neighborInvoiceDateMatches.Next.RegionData[0].StationCity }}</td>
                        <td style="font-size: 14px;">{{ neighborInvoiceDateMatches.Next.RegionData[0].TaxRegionName }}</td>
                        <td style="font-size: 14px;">{{ neighborInvoiceDateMatches.Next.RegionData[0].TaxRegionRate }}</td>
                        <td style="font-size: 14px;">
                            <v-btn
                                @click="handleSelectRegionByInvoiceDate(neighborInvoiceDateMatches.Next)"
                                color="indigo"
                                small
                                dense
                                outlined
                            >
                                Select
                            </v-btn>
                        </td>
                    </tr>
                </table>
                <div style="display: flex;justify-content: space-between;padding: 0 0 15px;">
                    <div style="width: 80px;height: 35px;"></div>
                    <v-btn text @click="neighborInvoiceDateMatches.Show = false">
                        Close
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="invoiceFileView" fullscreen>
            <v-card>
                <v-toolbar color="secondary" dense dark>
                    <v-btn dark outlined left @click="deleteInvoiceFile">
                        Delete invoice file
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-card-title primary-title>Invoice Document View</v-card-title>
                    <v-spacer></v-spacer>
                    <div style="width: 220px;display: flex;justify-content: flex-end;">
                        <v-btn dark icon left @click="invoiceFileView = false"><v-icon>mdi-close</v-icon></v-btn>
                    </div>
                </v-toolbar>
                <v-container grid-list-xs fluid>
                    <iframe :src="invoiceFileLink" style="width: 100%; height:100vh ;"></iframe>
                </v-container>
            </v-card>
        </v-dialog>
    </v-dialog>
</template>

<script>
import DateMenu from '../Global/Utils/DateMenu.vue';
import { delayedSearchItems } from '../../Utils/search';
import { validations } from '@/Utils/validation';
import { mask } from 'vue-the-mask';

import axios from 'axios';
export default {
    name: 'InvoiceCreateDialog',
    directives: { mask },
    components: {
        DateMenu
    },
    props: {
        dialogStatus: {
            type: Boolean,
            default: false
        },
        invoiceHeaders: Array,
        expenseHeaders: Array,
        types: Array,
        type: Object,
        dialogType: String,
        invoice: Object
    },
    data() {
        return {
            localStatus: false,
            //Form data
            validForm: true,
            rules: validations,
            invoiceForm: {
                id: '',
                model_type: '',
                model_id: '',
                invoice_number: '',
                maintenance_purchase_order_id: '',
                maintenance_vendor_id: '',
                maintenance_tax_region_id: '',
                region_id: '',
                company_id: '',
                invoice_issued_at: '',
                maintenance_started_at: '',
                maintenance_ended_at: '',
                comments: '',
                is_service_call: false,
                is_incident: false,
                is_oo_charge: false,
                incident_number: '',
                maintenance_type_id: '',
                // is_stock: false,
                //Trailer data
                hub_reading: '',
                //Truck data
                odometer_entry: '',
                odometer_exit: '',
                replacement_truck_id: '',
                another_replacement_truck: '',
                start_of_replacement_truck_use_at: '',
                end_of_replacement_truck_use_at: '',
                maintenance_vendor_rent_agreement_id: ''
            },
            invoiceExpenseForm: {
                quantity: 1,
                unit_cost: 10,
                tax: 0,
                subtotal_cost: 10,
                total_cost: 10,
                custom_tax_rate: 0,
                maintenance_expense_type_id: '',
                maintenance_expense_category_id: '',
                maintenance_expense_sub_category_id: '',
                maintenance_tire_brand_id: '',
                description: '',
                comments: '',
                user_id: ''
            },

            inventoryItemCurrentlyBuilt: {
                region_id: null,
                maintenance_vendor_id: null,
                maintenance_expense_category_id: null,
                maintenance_expense_sub_category_id: null,
                maintenance_item_id: null,
                unit_cost: null,
                tax_rate: null,
            },
            inventory: [],
            inventoryItemFound: {
                Show: false,
                Action: (type) => type === 'open' ?
                                this.inventoryItemFound.Show = true :
                                this.inventoryItemFound.Show = false,
                Data: {
                    Region: null,
                    Vendor: null,
                    Category: null,
                    Subcategory: null,
                    Item: null,
                    UnitCost: null,
                    TaxRate: null,
                    CurrentQuantity: null,
                },
                Status: false,
                TaxRate: {
                    Show: false,
                    Current: null,
                    New: null,
                }
            },

            currentExpenseList: {
                Show: false,
                CurrentHeaderValues: {
                    region_id: null,
                    maintenance_vendor_id: null,
                },
            },

            invoiceExpenses: [], //collection of expenses for the invoice
            payload: {}, //will be used to send data to the server: form, trucksDataForm, trailersDataForm,

            loading: {
                invoices: false,
                collections: false,
                expenses: false,
                models: false,
                purchaseOrders: false,
                companies: false,
                regions: false,
                taxRegions: false,
                vendors: false
            },
            panel: [0],
            expenseCategoriesFiltered: [],
            expenseSubCategoriesFiltered: [],
            itemsFiltered: [],

            model: {},
            apiModelId: '',
            apiModelName: '',

            apiVendorId: '',
            apiVendorName: '',

            collection: {},

            search: {
                model: '',
                purchaseOrder: '',
                company: '',
                region: '',
                taxRegion: '',
                vendor: ''
            },

            dateMenuProperties: {
                label: 'Invoice Date',
                hint: 'Select the date the invoice was issued',
                color: 'info',
                dense: true,
                display: ''
            },

            dateMenu: false,
            vendorInput: '',
            maintenanceTireBrands: [],
            neighborInvoiceDateMatches: {
                Show: false,
                Previous: {},
                Next: {},
            },
            files: null,
            invoiceFileView: false,
            invoiceFileLink: '',
            replacementTruckUseAtMenu: {
                start: false,
                end: false,
            },
        };
    },
    computed: {
        authentication() {
            return {
                headers: {
                    Authorization: 'Bearer ' + this.$store.state.token
                }
            };
        },
        defaultInvoiceForm() {
            return {
                id: '',
                model_type: this.type.laravel,
                model_id: '',
                invoice_number: '',
                maintenance_purchase_order_id: '',
                maintenance_vendor_id: '',
                maintenance_tax_region_id: '',
                region_id: '',
                company_id: '',
                invoice_issued_at: '',
                maintenance_started_at: '',
                maintenance_ended_at: '',
                comments: '',
                is_service_call: false,
                is_incident: false,
                is_oo_charge: false,
                incident_number: '',
                maintenance_type_id: '',
                // is_stock: false,
                //Trailer data
                hub_reading: '',
                //Truck data
                odometer_entry: '',
                odometer_exit: '',
                replacement_truck_id: '',
                another_replacement_truck: '',
                start_of_replacement_truck_use_at: '',
                end_of_replacement_truck_use_at: '',
                maintenance_vendor_rent_agreement_id: ''
            };
        },
        defaultInvoiceExpenseForm() {
            return {
                quantity: 1,
                unit_cost: 10,
                tax: 0,
                subtotal_cost: 10,
                total_cost: 10,
                custom_tax_rate: 0,
                maintenance_expense_type_id: '',
                maintenance_expense_category_id: '',
                maintenance_expense_sub_category_id: '',
                maintenance_tire_brand_id: '',
                description: '',
                comments: '',
                user_id: ''
            };
        },
        filteredVendorItems() {
            if (this.dialogStatus && this.dialogType == 'new') {
                if (!this.collection.vendors) {
                    return [];
                }

                return this.collection.vendors.filter(vnd => vnd.name.toLowerCase().startsWith(this.vendorInput))
                .sort((a, b) => {
                    const nameA = a.name.toLowerCase();
                    const nameB = b.name.toLowerCase();
                    if (nameA < nameB) return -1;
                    if (nameA > nameB) return 1;
                    return 0;
                });
            }
        }
    },
    async mounted() {
        await this.getCollections();
        console.log('Invoice dialog mounted', this.invoiceForm);
        console.log("filteredVendorItems", this.filteredVendorItems);
        this.localStatus = this.dialogStatus;
        //Add "actions" header column to the expenseHeaders
        // let idx = this.expenseHeaders.indexOf(header => header.value === 'actions');
        // if (idx === -1) {
        //     this.expenseHeaders.push({
        //         text: 'Actions',
        //         align: 'start',
        //         sortable: false,
        //         value: 'actions'
        //     });
        // }
    },
    watch: {
        //search for the model
        /*'search.model': {
            handler(newQuery, oldQuery) {
                if (
                    newQuery === oldQuery ||
                    newQuery === this.apiModelName ||
                    newQuery === null
                ) {
                    console.log(
                        'Model query is the same',
                        newQuery,
                        oldQuery,
                        'Model name:',
                        this.apiModelName
                    );
                    return;
                }
                console.log(
                    'Model query changed: ',
                    newQuery,
                    'Old query: ',
                    oldQuery
                );
                let url = '/v2/equipment/' + this.type.axios;
                delayedSearchItems(
                    url,
                    this.type.value,
                    newQuery,
                    this.authentication,
                    loading => {
                        this.loading.models = loading;
                    },
                    data => {
                        this.collection.models = data;
                    }
                );

                console.log('Model watcher: ', this.collection.models);
            },
            deep: true
        },*/
        /*'search.vendor': {
            handler(newQuery, oldQuery) {
                if (
                    newQuery === oldQuery ||
                    newQuery === this.apiVendorName ||
                    newQuery === null
                ) {
                    console.log(
                        'Vendor query is the same',
                        newQuery,
                        oldQuery,
                        'Vendor name:',
                        this.apiVendorName
                    );
                    return;
                }
                console.log(
                    'Vendor query changed: ',
                    newQuery,
                    'Old query: ',
                    oldQuery
                );
                let url = '/v2/maintenance/vendors';
                delayedSearchItems(
                    url,
                    'name',
                    newQuery,
                    this.authentication,
                    loading => {
                        this.loading.vendors = loading;
                    },
                    data => {
                        this.collection.vendors = data;
                    }
                );
            },
            deep: true
        },*/
        'invoiceForm.model_id': {
            handler(newModelId, oldModelId) {
                if (newModelId === oldModelId) {
                    return;
                }
                this.loading.purchaseOrders = true;
                console.log('Model id changed: ' + newModelId);
                console.log('type: ', this.type);
                //Get puchase orders where their model_id is the same as the selected model_id and are not yet in an invoice
                axios
                    .get(
                        '/v2/maintenance/purchase-orders/' +
                            this.type.axios +
                            '/' +
                            newModelId +
                            '/active',
                        this.authentication
                    )
                    .then(response => {
                        this.invoiceForm.maintenance_purchase_order_id = null;
                        this.loading.purchaseOrders = false;
                        this.collection.purchaseOrders = response.data;
                        console.log('From watcher pos: ', this.collection.purchaseOrders);
                    })
                    .catch(error => {
                        console.error(error);
                    });
            },
            deep: true
        },
        'invoiceForm.maintenance_tax_region_id': {
            handler(newTaxRegionId, oldTaxRegionId) {
                if (newTaxRegionId === oldTaxRegionId) {
                    return;
                }
                console.log('Tax region id changed: ' + newTaxRegionId);
                //Get puchase orders where their model_id is the same as the selected model_id and are not yet in an invoice
                this.invoiceExpenseForm.custom_tax_rate = this.getTaxRegionRate(
                    newTaxRegionId
                );

                // Set tax rate if is edit mode
                if (
                    this.dialogStatus == true &&
                    (this.dialogType == 'edit' || this.dialogType == 'view')
                ) {
                    console.log("Set tax rate if is edit mode");
                    for (let exp of this.invoiceExpenses) {
                        exp.custom_tax_rate = this.getTaxRegionRate(newTaxRegionId);
                        this.calculateItemCosts(exp);
                        this.updateExpense(exp);
                    }
                }

                if (this.type.value === 'supplies') {
                    this.checkTaxRate();
                }
            },
            deep: true
        },
        'invoiceForm.maintenance_type_id': {
            handler(newVal, oldVal) {
                if (newVal === oldVal) {
                    return;
                }
                console.log('Maintenance type id changed: ' + newVal);
                
                if (newVal === 1) {
                    this.invoiceForm.is_incident = 0;
                    this.invoiceForm.incident_number = '';
                }
            },
            deep: true
        },
        // Watch for changes in quantity
        'invoiceExpenseForm.quantity': function(newVal, oldVal) {
            this.calculateExpenseCosts();
        },
        // Watch for changes in unit_cost
        'invoiceExpenseForm.unit_cost': function(newVal, oldVal) {
            this.calculateExpenseCosts();
        },
        // Watch for changes in custom_tax_rate
        'invoiceExpenseForm.custom_tax_rate': function(newVal, oldVal) {
            this.calculateExpenseCosts();
        },
        localStatus: function() {
            if (this.localStatus == false) {
                this.$emit('update:status', this.localStatus);
            }
        },
        dialogStatus: async function() {
            this.localStatus = this.dialogStatus;
            await this.getCollections();
            console.log('Dialog status changed: ', this.dialogStatus);
            console.log('Type in new dialog: ', this.type);
            this.invoiceForm.model_type = this.type.laravel;
            this.invoiceExpenseForm.maintenance_expense_type_id = this.type.id;
            this.defaultInvoiceExpenseForm.maintenance_expense_type_id = this.type.id;
            this.getExpenseCategoriesFilteredByType(this.type.id);
            console.log(
                'Invoice expense type id: ',
                this.invoiceExpenseForm.maintenance_expense_type_id
            );
            console.log(
                'Default invoice expense type id: ',
                this.defaultInvoiceExpenseForm.maintenance_expense_type_id
            );
            this.collection.models = this.collection[this.type.axios];
            //If invoice object contains data, fill the form with the data
            if (
                this.dialogStatus == true &&
                (this.dialogType == 'edit' || this.dialogType == 'view')
            ) {
                console.log('Invoice is not empty: ', this.invoice);
                this.invoiceForm = this.invoice;
                this.dateMenuProperties.display = this.invoice.invoice_issued_at;
                this.invoiceExpenses = this.invoice.expenses;
                this.apiModelId = this.invoice.model_id;
                //search for the model_id
                axios
                    .get(
                        '/v2/equipment/' +
                            this.type.axios +
                            '/' +
                            this.invoice.model_id
                    )
                    .then(response => {
                        console.log("response by equipment", response.data);
                        this.collection.models = this.collection[
                            this.type.axios
                        ];
                        console.log(
                            'Model dialog collection:',
                            this.collection.models,
                            this.collection[this.type.axios],
                            this.collection.trailers,
                            this.collection.trucks
                        );
                        console.log(
                            'Model dialog load:',
                            this.collection.models
                        );

                        if (this.dialogType == 'edit' && this.type.value == 'truck') {
                            this.invoiceForm.model_id = response.data.TruckID;
                        } else if (this.dialogType == 'edit' && this.type.value == 'trailer') {
                            this.invoiceForm.model_id = response.data.TrailerId;
                        } else if (this.dialogType == 'edit' && this.type.value == 'supplies') {
                            this.invoiceForm.model_id = null;
                        }
                        
                        this.apiModelName = response.data.name;
                    })
                    .catch(error => {
                        console.error(error);
                    });
                //Get the purchase order
                if (this.invoice.maintenance_purchase_order_id) {
                    console.log('Get the po number ', this.invoice);
                    axios
                        .get(
                            '/v2/maintenance/purchase-orders/' +
                                this.invoice.maintenance_purchase_order_id
                        )
                        .then(response => {
                            this.collection.purchaseOrders = [response.data];
                            this.invoiceForm.maintenance_purchase_order_id =
                                response.data.id;
                            console.log('Flag po: ', this.collection.purchaseOrders);
                        })
                        .catch(error => {
                            console.error(error);
                        });
                }
                //Get the maintenance vendor
                axios
                    .get(
                        '/v2/maintenance/vendors/' + this.invoice.vendor.id,
                        this.authentication
                    )
                    .then(response => {
                        // this.collection.vendors = [response.data];
                        this.invoiceForm.maintenance_vendor_id =
                            response.data.id;
                        this.apiVendorName = response.data.name;
                        this.apiVendorId = response.data.id;
                        console.log("from vendors request: ", response.data, this.collection.vendors, this.invoiceForm.maintenance_vendor_id);
                    })
                    .catch(error => {
                        console.error(error);
                    });
            } else if (this.dialogStatus == true && this.dialogType == 'new') {
                this.invoiceForm = this.defaultInvoiceForm;
                this.invoiceExpenses = [];
                this.invoiceExpenseForm = this.defaultInvoiceExpenseForm;
            }
        }
    },
    methods: {
        manageOnChangeEvent(source, property) {
            // invoiceForm source
            if (
                (property === 'region_id' && this.type.value === 'supplies') ||
                (property === 'maintenance_vendor_id' && this.type.value === 'supplies')
            ) {
                this.checkInventoryItemCurrentlyBuilt(source, property);
            }
            
            if (
                (property === 'region_id' || property === 'maintenance_vendor_id') &&
                (this.invoiceExpenses.length && this.dialogType !== 'edit')
            ) {
                console.log("There are expenses currently on the list!");
                console.log(this.invoiceExpenses);
                
                this.currentExpenseList.Show = true;
            } else if (
                (property === 'region_id' || property === 'maintenance_vendor_id') &&
                this.dialogType !== 'edit'
            ) {
                this.currentExpenseList.CurrentHeaderValues[property] = this.invoiceForm[property];
            }

            if (
                (property === 'invoice_issued_at' || property === 'model_id') &&
                this.type.value !== 'supplies' &&
                this.invoiceForm.invoice_issued_at !== '' &&
                this.invoiceForm.model_id !== ''
            ) {
                console.log("getRegionByInvoiceDateAndUnit: ", this.invoiceForm.invoice_issued_at, this.invoiceForm.model_id);
                this.neighborInvoiceDateMatches.Previous = {};
                this.neighborInvoiceDateMatches.Next = {};
                this.getRegionByInvoiceDateAndUnit();
            }

            // invoiceExpenseForm source
            if (property === 'maintenance_expense_category_id') {
                this.getExpenseSubCategoriesFilteredByCategory(this[source][property]);
            } 
            
            if (property === 'maintenance_expense_sub_category_id' && this.type.value === 'supplies') {
                this.getItemsFilteredBySubCategories(this[source][property]);
            } else if (property === 'maintenance_expense_sub_category_id' && this.type.value !== 'supplies') {
                this.getExpenseSubCategoriesFilteredByCategory(this.invoiceExpenseForm.maintenance_expense_category_id);
            }

            if (property === 'maintenance_item_id' && this.type.value === 'supplies') {
                this.checkInventoryItemCurrentlyBuilt(source, property);
            }

            if (property === 'custom_tax_rate' && this.type.value === 'supplies') {
                this.checkTaxRate();
            }

            if (property === 'unit_cost' && this.type.value === 'supplies') {
                this.setUnitCost();
            }
            
        },
        handleSelectRegionByInvoiceDate(data) {
            if (data.RegionData[0].PrincipalRegionID !== null) {
                this.invoiceForm.region_id = data.RegionData[0].PrincipalRegionID;
            } else {
                this.$store.dispatch('setSnackbar', {
                    text: 'No region found',
                    color: 'error'
                });
            }

            if (data.RegionData[0].TaxRegionId !== null) {
                this.invoiceForm.maintenance_tax_region_id = data.RegionData[0].TaxRegionId;
            } else {
                this.$store.dispatch('setSnackbar', {
                    text: 'No tax region found',
                    color: 'error'
                });
            }

            this.neighborInvoiceDateMatches.Previous = {};
            this.neighborInvoiceDateMatches.Next = {};
            this.neighborInvoiceDateMatches.Show = false;
        },
        getRegionByInvoiceDateAndUnit() {
            let str = this.$store;
            str.state.isLoading = true;
            let params = {
                InvoiceType: this.type.value,
                UnitId: this.invoiceForm.model_id,
                InvoiceDate: this.invoiceForm.invoice_issued_at,
            };
            console.log("Region by invoice params", params);
            axios
                .post(
                    '/v2/maintenance/invoices/get/region-by-params',
                    params,
                    this.authentication
                )
                .then(response => {
                    console.log(response);
                    let data = response.data;

                    if (data.Type === 1) {
                        // Matched shift
                        if (typeof data.Data.Matched == 'object') {
                            if ("RegionData" in data.Data.Matched && data.Data.Matched.RegionData.length) {
                                console.log("This is Matched");
                                if (data.Data.Matched.RegionData[0].PrincipalRegionID !== null) {
                                    this.invoiceForm.region_id = data.Data.Matched.RegionData[0].PrincipalRegionID;
                                } else {
                                    str.dispatch('setSnackbar', {
                                        text: 'No region found',
                                        color: 'error'
                                    });
                                }

                                if (data.Data.Matched.RegionData[0].TaxRegionId !== null) {
                                    this.invoiceForm.maintenance_tax_region_id = data.Data.Matched.RegionData[0].TaxRegionId;
                                } else {
                                    str.dispatch('setSnackbar', {
                                        text: 'No tax region found',
                                        color: 'error'
                                    });
                                }
                            }
                        } else {
                            str.dispatch('setSnackbar', {
                                text: 'No matches found',
                                color: 'error'
                            });
                        }
                    } else if (data.Type === 5) {
                        // No matches
                        str.dispatch('setSnackbar', {
                            text: 'No neighboring dates found for the entered invoice date',
                            color: 'error'
                        });
                    } else if (data.Type === 2 || data.Type === 3 || data.Type === 4) {
                        console.log("Previous and Next");

                        if (typeof data.Data.Previous == 'object') {
                            if ("RegionData" in data.Data.Previous && data.Data.Previous.RegionData.length) {
                                this.neighborInvoiceDateMatches.Previous = data.Data.Previous;
                                console.log("This is Previous");
                            }
                        }

                        if (typeof data.Data.Next == 'object') {
                            if ("RegionData" in data.Data.Next && data.Data.Next.RegionData.length) {
                                this.neighborInvoiceDateMatches.Next = data.Data.Next;
                                console.log("This is Next");
                            }
                        }

                        if (Object.keys(this.neighborInvoiceDateMatches.Previous).length || Object.keys(this.neighborInvoiceDateMatches.Next).length) {
                            this.neighborInvoiceDateMatches.Show = true;
                        } else {
                            str.dispatch('setSnackbar', {
                                text: 'No neighboring dates found for the entered invoice date',
                                color: 'error'
                            });
                        }
                    } else {
                        str.dispatch('setSnackbar', {
                            text: 'No matches found',
                            color: 'error'
                        });
                    }

                    str.state.isLoading = false;
                })
                .catch(error => {
                    console.log(error);
                    str.state.isLoading = false;

                    if (error != 'undefined' && Object.keys(error).length) {
                        if (error.response.status == 400) {
                            str.dispatch('setSnackbar', {
                                text: error.response.data,
                                color: 'error'
                            });
                        }
                    }
                });
        },
        manageCurrentExpenseList(action) {
            console.log(action);
            console.log("Dialog type", this.dialogType);

            // Return header variables to their previous value
            if (this.currentExpenseList.CurrentHeaderValues.region_id !== null) {
                this.invoiceForm.region_id = this.currentExpenseList.CurrentHeaderValues.region_id;
            }

            if (this.currentExpenseList.CurrentHeaderValues.maintenance_vendor_id !== null) {
                this.invoiceForm.maintenance_vendor_id = this.currentExpenseList.CurrentHeaderValues.maintenance_vendor_id;
            }

            if (action == 'save' && this.dialogType !== 'edit') {
                console.log("save");
                this.submit();
            } else if (action == 'new' && this.dialogType !== 'edit') {
                this.resetForm();
                this.invoiceForm.model_type = this.type.laravel;
            } /*else if (action == 'close' && this.dialogType !== 'edit') {
                // Return header variables to their previous value
                if (this.currentExpenseList.CurrentHeaderValues.region_id !== null) {
                    this.invoiceForm.region_id = this.currentExpenseList.CurrentHeaderValues.region_id;
                }

                if (this.currentExpenseList.CurrentHeaderValues.maintenance_vendor_id !== null) {
                    this.invoiceForm.maintenance_vendor_id = this.currentExpenseList.CurrentHeaderValues.maintenance_vendor_id;
                }
            }*/

            this.currentExpenseList.Show = false;
        },
        manageTaxRate(action) {
            if (action === 'continue') {
                this.inventoryItemFound.Action('close');
                console.log("Continue with the new tax rate");
            } else {
                // return to original value
                console.log("Return to original tax rate");
                this.invoiceExpenseForm.custom_tax_rate = parseFloat(this.inventoryItemFound.Data.TaxRate).toFixed(2);
                this.inventoryItemFound.Action('close');
            }
        },
        checkTaxRate() {
            console.log("Check tax rate");
            if (this.inventoryItemFound.Status) {
                console.log("Item found");
                let customTaxRate = parseFloat(this.invoiceExpenseForm.custom_tax_rate).toFixed(2);
                let itemTaxRate = parseFloat(this.inventoryItemFound.Data.TaxRate).toFixed(2);
                
                if (customTaxRate !== itemTaxRate) {
                    this.inventoryItemFound.TaxRate.Current = itemTaxRate;
                    this.inventoryItemFound.TaxRate.New = customTaxRate;
                    this.inventoryItemFound.TaxRate.Show = true;
                    this.inventoryItemFound.Action('open');
                }
            }
        },
        setUnitCost() {
            this.invoiceExpenseForm.unit_cost = parseFloat(this.invoiceExpenseForm.unit_cost).toFixed(2);
            console.log(this.invoiceExpenseForm.unit_cost);
            this.checkInventoryItemCurrentlyBuilt('invoiceExpenseForm', 'unit_cost');
        },
        checkInventoryItemCurrentlyBuilt(source, property) {
            this.inventoryItemCurrentlyBuilt[property] = this[source][property];
            console.log("Inventory Item Currently Built", this.inventoryItemCurrentlyBuilt);
            let inventoryItemFound = this.inventory.filter(item => {
                return item.region_id === this.inventoryItemCurrentlyBuilt.region_id &&
                item.maintenance_vendor_id === this.inventoryItemCurrentlyBuilt.maintenance_vendor_id &&
                item.maintenance_expense_category_id === this.inventoryItemCurrentlyBuilt.maintenance_expense_category_id &&
                item.maintenance_expense_subcategory_id === this.inventoryItemCurrentlyBuilt.maintenance_expense_sub_category_id &&
                item.maintenance_item_id === this.inventoryItemCurrentlyBuilt.maintenance_item_id &&
                item.unit_cost === this.inventoryItemCurrentlyBuilt.unit_cost
            });

            if (inventoryItemFound.length) {
                this.invoiceExpenseForm.current_quantity = inventoryItemFound[0].quantity;

                this.inventoryItemFound.Data.Region = inventoryItemFound[0].region_name;
                this.inventoryItemFound.Data.Vendor = inventoryItemFound[0].maintenance_vendor_name;
                this.inventoryItemFound.Data.Category = inventoryItemFound[0].maintenance_expense_category_name;
                this.inventoryItemFound.Data.Subcategory = inventoryItemFound[0].maintenance_expense_subcategory_name;
                this.inventoryItemFound.Data.Item = inventoryItemFound[0].item_name;
                this.inventoryItemFound.Data.UnitCost = inventoryItemFound[0].unit_cost;
                this.inventoryItemFound.Data.TaxRate = inventoryItemFound[0].tax_rate;
                this.inventoryItemFound.Data.CurrentQuantity = inventoryItemFound[0].quantity;
                this.inventoryItemFound.Status = true;
                
                this.inventoryItemFound.Action('open');
            } else {
                this.invoiceExpenseForm.current_quantity = 0;

                this.inventoryItemFound.Data.Region = null;
                this.inventoryItemFound.Data.Vendor = null;
                this.inventoryItemFound.Data.Category = null;
                this.inventoryItemFound.Data.Subcategory = null;
                this.inventoryItemFound.Data.Item = null;
                this.inventoryItemFound.Data.UnitCost = null;
                this.inventoryItemFound.Data.TaxRate = null;
                this.inventoryItemFound.Data.CurrentQuantity = null;
                this.inventoryItemFound.Status = false;
            }

            console.log(inventoryItemFound);
        },
        calculateExpenseCosts() {
            // Ensure the quantity and unit_cost are parsed as floats only once
            const quantity = parseFloat(this.invoiceExpenseForm.quantity);
            const unitCost = parseFloat(this.invoiceExpenseForm.unit_cost);

            // Calculate subtotalCost directly without redundant parseFloat calls
            const subtotalCost = quantity * unitCost;

            // Calculate tax based on the subtotalCost, avoiding redundant parseFloat calls
            const tax =
                (parseFloat(subtotalCost) *
                    this.invoiceExpenseForm.custom_tax_rate) /
                100;

            // Calculate total cost by converting subtotalCost and tax back to float for summation
            const totalCost = parseFloat(subtotalCost) + parseFloat(tax);

            // Update the form values directly, no need for parseFloat as they're already formatted strings
            this.invoiceExpenseForm.subtotal_cost = subtotalCost;
            this.invoiceExpenseForm.tax = tax;
            this.invoiceExpenseForm.total_cost = totalCost;
            this.calculateInvoiceCosts();
        },
        calculateItemCosts(item) {
            // Ensure the quantity and unit_cost are parsed as floats only once
            const quantity = parseFloat(item.quantity);
            const unitCost = parseFloat(item.unit_cost);

            // Calculate subtotalCost directly without redundant parseFloat calls
            const subtotalCost = quantity * unitCost;

            // Calculate tax based on the subtotalCost, avoiding redundant parseFloat calls
            const tax = (parseFloat(subtotalCost) * item.custom_tax_rate) / 100;

            // Calculate total cost by converting subtotalCost and tax back to float for summation
            const totalCost = parseFloat(subtotalCost) + parseFloat(tax);

            // Update the form values directly, no need for parseFloat as they're already formatted strings
            item.subtotal_cost = subtotalCost;
            item.tax = tax;
            item.total_cost = totalCost;

            console.log("item updated: ", item);
        },
        calculateInvoiceCosts() {
            let subtotalCost = 0;
            let totalCost = 0;
            this.invoiceExpenses.forEach(expense => {
                subtotalCost += parseFloat(expense.subtotal_cost);
                totalCost += parseFloat(expense.total_cost);
            });
            this.invoiceForm.subtotal_cost = subtotalCost;
            this.invoiceForm.total_cost = totalCost;
        },
        getActiveModelType(type) {
            //If the "type" parameter is "transportation" check if the model type is "App\\Truck" or "App\\Trailer" and return true
            if (type == 'transportation') {
                return (
                    this.type.value === 'truck' || this.type.value === 'trailer'
                );
            } else if (type === this.type.value) {
                return true;
            } else {
                return false;
            }
        },
        resetForm() {
            console.log("reset form");
            this.invoiceForm = this.defaultInvoiceForm;
            this.invoiceExpenses = [];
            this.invoiceExpenseForm = this.defaultInvoiceExpenseForm;

            if (this.type.value === 'supplies') {
                this.invoiceExpenseForm.maintenance_item_id = '';
                this.invoiceExpenseForm.current_quantity = 0;
            }

            console.log("invoiceForm", this.invoiceForm);
            console.log("invoiceExpenses", this.invoiceExpenses);
            console.log("invoiceExpenseForm", this.invoiceExpenseForm);
        },
        handleCloseInvoiceForm() {
            this.resetForm();
            this.localStatus = false;
            this.$emit('update:invoices');
        },
        async submit() {
            //Calculate the subtotal cost and total cost
            let subtotalCost = 0;
            let totalCost = 0;
            this.invoiceExpenses.forEach(expense => {
                subtotalCost += parseFloat(expense.subtotal_cost);
                totalCost += parseFloat(expense.total_cost);
            });
            this.invoiceForm.subtotal_cost = subtotalCost;
            this.invoiceForm.total_cost = totalCost;
            this.payload = {
                form: this.invoiceForm,
                invoiceExpenses: this.invoiceExpenses ?? [],
                invoiceType: this.type.axios
            };
            console.log(this.payload);
            let str = this.$store;
            str.state.isLoading = true;
            if (this.dialogType === 'edit') {
                await axios
                    .put(
                        '/v2/maintenance/invoices/' +
                            this.type.axios +
                            '/' +
                            this.invoiceForm.id,
                        this.payload,
                        this.authentication
                    )
                    .then(async response => {
                        console.log(response);

                        console.log(
                            'Files: ',
                            this.invoice,
                            this.files,
                            Object.keys(this.files).length
                        );
                        if (!this.invoice.files.length && this.files && this.files.name) {
                            console.log('File test');
                            await this.saveInvoiceFile(response.data);
                        }

                        this.invoiceForm = this.defaultInvoiceForm;
                        this.invoiceFileView = false;
                        //Close the dialog
                        this.localStatus = false;
                        //Issue a snackbar message
                        str.state.isLoading = false;
                        this.$store.dispatch('setSnackbar', {
                            text: 'Invoice updated successfully',
                            color: 'success'
                        });
                        //Emmit the signal to update the invoice list
                        this.$emit('update:invoices');
                    })
                    .catch(error => {
                        str.state.isLoading = false;
                        console.error(error);
                    });
            } else {
                await axios
                    .post(
                        '/v2/maintenance/invoices/' + this.type.axios,
                        this.payload,
                        this.authentication
                    )
                    .then(async response => {
                        console.log(response.data);
                        
                        if (this.files && this.files.name) {
                            await this.saveInvoiceFile(response.data);
                        }

                        this.invoiceForm = this.defaultInvoiceForm;
                        
                        console.log("save invoice");
                        this.invoiceFileView = false;

                        this.invoiceForm.model_type = this.type.laravel;
                        //Close the dialog
                        this.localStatus = false;
                        //Issue a snackbar message
                        str.state.isLoading = false;
                        this.$store.dispatch('setSnackbar', {
                            text: 'Invoice created successfully',
                            color: 'success'
                        });
                        //Emmit the signal to update the invoice list
                        this.$emit('update:invoices');
                    })
                    .catch(error => {
                        str.state.isLoading = false;
                        console.error(error);
                    });
            }
            console.log('Payload: ', this.payload);
        },
        async saveInvoiceFile(invoice) {
            const str = this.$store;
            const formData = new FormData();
            formData.append('files[]', this.files);
            formData.append('invoice_id', invoice.id);
            formData.append('invoice_type', this.type.axios);

            console.log('Save invoice file');
            str.state.isLoading = true;
            await axios
                .post(
                    '/v2/maintenance/invoices/files/add', formData,
                    {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token,
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )
                .then(response => {
                    console.log("response: ", response.data);
                    this.files = {};
                    str.state.isLoading = false;
                })
                .catch(error => {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        viewInvoiceFile() {
            console.log(this.invoice);
            if (!this.invoice.files.length) {
                this.$store.dispatch('setSnackbar', {
                    text: 'No files to view.',
                    color: 'warning'
                });
                return;
            }
            
            let params = {
                invoice: this.invoice,
            };
            this.$store.state.isLoading = true;
            axios
                .post('/v2/maintenance/invoices/files/view', params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    this.invoiceFileLink = response.data;
                    this.invoiceFileView = true;
                    this.$store.state.isLoading = false;
                })
                .catch(error => {
                    console.log(error);
                    this.$store.state.isLoading = false;
                })
        },
        deleteInvoiceFile() {
            console.log('Delete invoice file');
            let params = {
                invoice: this.invoice,
            };
            this.$store.state.isLoading = true;
            axios
                .post('/v2/maintenance/invoices/files/delete', params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    this.invoiceFileLink = '';
                    this.invoiceFileView = false;
                    this.invoice.files = [];
                    this.$store.state.isLoading = false;
                    this.$store.dispatch('setSnackbar', {
                        text: 'Invoice file successfully deleted.',
                        color: 'success'
                    });
                })
                .catch(error => {
                    console.log(error);
                    this.$store.state.isLoading = false;
                })
        },
        handleFileInput() {
            if (this.invoice.files.length) {
                this.files = {};
                this.$store.dispatch('setSnackbar', {
                    text: 'You cannot add more files, one already exists.',
                    color: 'warning'
                });
                return;
            }
        },
        getTotalCost(
            type,
            costType //type: 'invoice' or 'expense', costType: 'subtotal', 'tax', or 'total'
        ) {
            let total = 0;
            if (type == 'invoice') {
                this.invoiceExpenses.forEach(expense => {
                    total += parseFloat(expense[costType]);
                });
            } else if (type == 'expense') {
                total = this.invoiceExpenses.reduce(
                    (acc, expense) => acc + parseFloat(expense[costType]),
                    0
                );
            }
            return total;
        },

        getTaxRegionRate(id) {
            if (id) {
                let taxRegion = this.collection.taxRegions.find(
                    taxRegion => taxRegion.id == id
                );
                return taxRegion ? taxRegion.rate : '';
            } else {
                return '';
            }
        },

        addExpense() {
            console.log('Adding expense');
            this.invoiceExpenses.push(this.invoiceExpenseForm);
            console.log('Expenses: ', this.invoiceExpenses);
            console.log('Resetting expense form');
            //Reset the expense form
            this.invoiceExpenseForm = {
                maintenance_expense_category_id: this.invoiceExpenseForm
                    .maintenance_expense_category_id,
                maintenance_expense_sub_category_id: this.invoiceExpenseForm
                    .maintenance_expense_sub_category_id,
                quantity: 1,
                unit_cost: 10,
                tax: 0,
                subtotal_cost: 0,
                total_cost: 0,
                custom_tax_rate: this.invoiceForm.maintenance_tax_region_id
                    ? this.getTaxRegionRate(
                          this.invoiceForm.maintenance_tax_region_id
                      )
                    : 0,
                maintenance_expense_type_id: this.type.id,
                maintenance_tire_brand_id: '',
                description: '',
                comments: '',
                user_id: ''
            };

            if (this.type.value === 'supplies') {
                this.invoiceExpenseForm.maintenance_item_id = this.invoiceExpenseForm.maintenance_item_id;
            }

            this.calculateExpenseCosts();
            this.calculateInvoiceCosts();
            console.log('Expense form reset: ', this.invoiceExpenseForm);
            this.inventoryItemFound.Status = false;
        },
        updateExpense(item) {
            console.log('Updating expense: ', item);
            let index = this.invoiceExpenses.indexOf(item);
            this.invoiceExpenses.splice(index, 1, item);
            this.calculateExpenseCosts();
        },
        deleteExpense(item) {
            console.log('Deleting expense: ', item);
            let index = this.invoiceExpenses.indexOf(item);
            this.invoiceExpenses.splice(index, 1);
            this.calculateExpenseCosts();
        },

        getExpenseCategoriesFilteredByType(expenseType) {
            if (!expenseType) return [];
            console.log('Expense type: ', expenseType);
            console.log(
                'Expense categories: ',
                this.collection.expenseCategories
            );
            this.expenseCategoriesFiltered = this.collection.expenseCategories.filter(
                expenseCategory =>
                    expenseCategory.maintenance_expense_type_id == expenseType
            );
            console.log(
                'Filtered categories: ',
                this.expenseCategoriesFiltered
            );
        },

        getExpenseSubCategoriesFilteredByCategory(expenseCategory) {
            console.log('Expense form flag: ', this.invoiceExpenseForm);
            if (!expenseCategory) {
                this.expenseSubCategoriesFiltered = [];
                return [];
            }
            console.log('New expense category: ', expenseCategory);
            // this.invoiceExpenseForm.maintenance_expense_sub_category_id = '';
            this.expenseSubCategoriesFiltered = this.collection.expenseSubCategories.filter(
                expenseSubcategory =>
                    expenseSubcategory.maintenance_expense_category_id ==
                    expenseCategory
            );
            console.log(
                'Filtered subcategories: ',
                this.expenseSubCategoriesFiltered
            );
            this.checkInventoryItemCurrentlyBuilt('invoiceExpenseForm', 'maintenance_expense_category_id');
        },
        getItemsFilteredBySubCategories(expenseSubcategory) {
            console.log("item", expenseSubcategory);
            if (!expenseSubcategory) {
                this.itemsFiltered = [];
                return [];
            }
            console.log('New expense subcategory: ', expenseSubcategory);
            this.invoiceExpenseForm.maintenance_item_id = '';
            this.itemsFiltered = this.collection.items.filter(
                item =>
                    item.maintenance_expense_subcategory_id ==
                    expenseSubcategory
            );
            console.log(
                'Filtered items: ',
                this.itemsFiltered
            );
            this.checkInventoryItemCurrentlyBuilt('invoiceExpenseForm', 'maintenance_expense_sub_category_id');
        },
        getCategoryName(id) {
            if (id) {
                console.log('Category ID: ', id);
                let category = this.collection.expenseCategories.find(
                    category => category.id == id
                );
                return category ? category.name : '';
            } else {
                return '';
            }
        },
        getSubcategoryName(id) {
            if (id) {
                console.log('Subcategory ID: ', id);
                let subcategory = this.collection.expenseSubCategories.find(
                    subcategory => subcategory.id == id
                );
                return subcategory ? subcategory.name : '';
            } else {
                return '';
            }
        },
        getItemName(id) {
            if (id) {
                console.log('Item ID: ', id);
                let item = this.collection.items.find(
                    itm => itm.id == id
                );
                return item ? item.name : '';
            } else {
                return '';
            }
        },
        getExpenseTotals(expenses) {
            //Return total costs and taxes for the expenses
            let totalCost = 0;
            let totalTax = 0;
            console.log(expenses);
            expenses.forEach(expense => {
                //values are in text format, convert to numbers of no more than 2 decimal places, remember that these are currencies
                let cost = parseFloat(expense.total_cost);
                let tax = parseFloat(expense.tax);
                console.log(cost, tax);
                totalCost += cost;
                totalTax += tax;
            });
            totalCost = Math.round(totalCost * 100) / 100;
            totalTax = Math.round(totalTax * 100) / 100;
            console.log(totalCost, totalTax);
            const formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD'
            });

            return {
                totalCost: formatter.format(totalCost),
                totalTax: formatter.format(totalTax)
            };
        },
        findTruck(id) {
            return this.trucks.find(truck => truck.TruckID == id);
        },
        findTrailer(id) {
            return this.trailers.find(trailer => trailer.TrailerId == id);
        },
        modelName(modelType, modelId) {
            if (modelType && modelId) {
                switch (modelType) {
                    case 'truck':
                        return (
                            this.findTruck(modelId).Truck + ' (' + modelId + ')'
                        );
                    case 'trailer':
                        return (
                            this.findTrailer(modelId).Trailer +
                            ' (' +
                            modelId +
                            ')'
                        );
                    default:
                        return console.error('Model type not found');
                }
            } else {
                return console.error('Model type and ID are required');
            }
        },
        getModelList(listType) {
            if (!this.invoiceForm.model_type) {
                return [];
            }

            const modelTypeMappings = {
                'App\\Truck': {
                    items: this.trucks,
                    text: 'Truck',
                    value: 'TruckID'
                },
                'App\\Trailer': {
                    items: this.trailers,
                    text: 'Trailer',
                    value: 'TrailerId'
                }
            };

            const defaultValues = {
                items: [],
                itemText: '',
                itemValue: ''
            };

            const modelType =
                modelTypeMappings[this.invoiceForm.model_type] || defaultValues;
            return modelType[listType] || [];
        },
        handleVendorInput(value) {
            console.log("from handle vendor input", value);

            if (value !== null && value !== undefined && this.dialogStatus && this.dialogType == 'new') {
                this.vendorInput = value.toLowerCase();
            }

            console.log(this.vendorInput);
        },

        /**
         * Loaders
         * These methods are used to load data from the server
         */
        async getCollections(loading) {
            let token = this.authentication;

            if (loading) this.loading.collections = true;
            await axios
                .get('/v2/maintenance/collections/trailer-invoice', token)
                .then(response => {
                    this.collection = response.data;
                    console.log("collection", this.collection);
                    this.collection.models = this.collection[this.type.axios];
                    this.inventory = this.collection.inventory;
                    this.maintenanceTireBrands = this.collection.maintenanceTireBrands;
                    console.log(this.type);
                    console.log("collections", this.collection);
                    console.log(this.inventory);
                })
                .finally(() => {
                    if (loading) this.loading.collections = false;

                    if (this.type.value === 'supplies') {
                        this.invoiceExpenseForm.maintenance_item_id = '';
                        this.invoiceExpenseForm.current_quantity = 0;
                    }

                    this.getExpenseCategoriesFilteredByType(this.type.id);
                })
                .catch(error => {
                    console.error(error);
                });
        },
        showTireBrand() {
            switch (this.type.value) {
                case 'trailer':
                    return this.invoiceExpenseForm.maintenance_expense_category_id == 1 &&
                            this.invoiceExpenseForm.maintenance_expense_sub_category_id == 1;
                case 'truck':
                    return this.invoiceExpenseForm.maintenance_expense_category_id == 19 &&
                            this.invoiceExpenseForm.maintenance_expense_sub_category_id == 53;
                default:
                    return false;
            }
        }
    }
};
</script>
<style scoped>
    table {
      border-collapse: collapse;
      width: 100%;
    }
    th, td {
      border: 1px solid #dddddd;
      padding: 8px;
      text-align: left;
    }
</style>
